import React from "react";
import * as L from "lucide-react";

/**
 * Wrapper sobre lucide-react con valores por defecto del DS Kronaly:
 *  - tamaño 16
 *  - stroke 1.5
 *  - color heredado vía currentColor
 *
 * Uso: <Icon name="LayoutDashboard" /> o <Icon name="Plus" size={20} />.
 *
 * Si no se encuentra el icono devuelve null en producción y un placeholder
 * con borde rojo en desarrollo, para que el problema sea visible al portar.
 */
export function Icon({ name, size = 16, strokeWidth = 1.5, className, style }) {
  if (!name) return null;
  const Cmp = L[name];
  if (!Cmp) {
    if (process.env.NODE_ENV !== "production") {
      return (
        <span
          title={`Icon "${name}" no existe en lucide-react`}
          style={{
            display: "inline-block",
            width: size,
            height: size,
            border: "1px dashed var(--kr-danger-500)",
            color: "var(--kr-danger-500)",
            fontSize: 9,
            lineHeight: `${size}px`,
            textAlign: "center",
            ...(style || {}),
          }}
        >?</span>
      );
    }
    return null;
  }
  return (
    <Cmp
      size={size}
      strokeWidth={strokeWidth}
      className={className}
      style={style}
      aria-hidden="true"
    />
  );
}

export default Icon;
